<template>
  <card>
    <h2
      slot="header"
      class="mb-2">Edit User</h2>
    <ValidationObserver
      ref="form"
      v-slot="{ invalid, validate }">
      <form
        @submit.prevent="validate().then(updateUser)"
        autocomplete="off">
        <div class="row">
          <div class="col-xl-4 col-6">
            <ValidationProvider
              name="First Name"
              rules="required"
              v-slot="{ errors }">
              <base-input
                name="fname"
                autocomplete="off"
                type="text"
                label="First Name"
                placeholder="First Name"
                v-model.trim="userEdit.first_name"
                :error="errors[0]" />
            </ValidationProvider>
          </div>
          <div class="col-xl-4 col-6">
            <ValidationProvider
              name="Last Name"
              rules="required"
              v-slot="{ errors }">
              <base-input
                name="lname"
                autocomplete="off"
                type="text"
                label="Last Name"
                placeholder="Last Name"
                v-model.trim="userEdit.last_name"
                :error="errors[0]" />
            </ValidationProvider>
          </div>
          <div class="col-xl-4 col-12">
            <ValidationProvider
              name="Email"
              rules="email"
              v-slot="{ errors }">
              <base-input
                name="email"
                type="email"
                label="Email address"
                placeholder="Email"
                v-model.trim="userEdit.email"
                :error="errors[0]" />
            </ValidationProvider>
          </div>
        </div>
        <div class="row">
          <div class="col-4">
            <ValidationProvider
              name="Username"
              rules="required"
              v-slot="{ errors }">
              <base-input
                name="username"
                type="text"
                label="Username"
                placeholder="Username"
                v-model.trim="userEdit.username"
                autocomplete="new-username"
                :error="errors[0]" />
            </ValidationProvider>
          </div>
          <div class="col-4">
            <label>Role</label>
            <ValidationProvider
              name="Role"
              rules="required"
              v-slot="{ errors }">
              <v-select
                v-model="userEdit.role"
                :options="userRoles"
                placeholder="Select role"
                label="label">
                <template
                  slot="option"
                  slot-scope="option">
                  {{ option.label }}
                </template>
              </v-select>
              <label class="error">{{ errors[0] }}</label>
            </ValidationProvider>
          </div>
          <div class="col-4">
            <ValidationProvider
              name="Password"
              :rules="`min:${passwordMinLength}`"
              v-slot="{ errors }">
              <base-input
                unlock
                name="password"
                type="password"
                label="Password"
                placeholder="********"
                v-model.trim="userEdit.password"
                autocomplete="new-password"
                :error="errors[0]" />
            </ValidationProvider>
          </div>
        </div>
        <div class="row">
          <div class="col-4">
            <label>Allow user to login</label>
            <div class="form-group has-label">
              <el-switch
                v-model="userStatus"
                active-text="Yes"
                inactive-text="No" />
            </div>
          </div>
        </div>
        <base-button
          id="updateUser"
          :disabled="isUnModified || invalid"
          native-type="submit"
          type="primary"
          class="btn-fill">
          Update User
        </base-button>
      </form>
    </ValidationObserver>
  </card>
</template>
<script>
import _ from 'lodash';
import vSelect from 'vue-select';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import { Switch } from 'element-ui';
import { Modal } from 'src/components/UI';
import UserAddForm from 'src/modules/User/Users/_components/UserAddForm.vue';

export default {
  name: 'UserEditForm',
  components: {
    Modal,
    ValidationObserver,
    ValidationProvider,
    vSelect,
    [Switch.name]: Switch,
    UserAddForm,
  },
  props: {
    user: {
      type: Object,
      required: true,
    },
    userRoles: {
      type: Array,
      required: true,
    },
    passwordMinLength: {
      type: Number,
      required: true,
    },
    userAdded: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      userEdit: { ...this.user },
    };
  },
  computed: {
    isUnModified() {
      return _.isEqual(this.user, this.userEdit);
    },
    userStatus: {
      get() {
        return this.userEdit.status === 'active';
      },
      set(active) {
        this.userEdit.status = active ? 'active' : 'inactive';
      },
    },
  },
  methods: {
    updateUser() {
      this.$emit('updateUser', this.userEdit);
      this.$refs.form.reset();
    },
  },
  watch: {
    user(update) {
      this.userEdit = { ...update };
    },
  },
};
</script>
